import { Box, Button, Card, Checkbox, Grid, List, ListItem, Typography, Snackbar, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { returnNetwork } from "../utils/NetworkFunctions.js";
import { getAddressByCryptoCurrencyNetworkAgent } from "../actions/deposit.js";
import one from "../assets/images/1.png";
import two from "../assets/images/2.png";
import three from "../assets/images/3.png";
import { shortAddress } from "../utils/cryptoCurrenciesUtils.js";

const DepositAddress = ({ cryptoCurrency, network, setAgreement, agreement, address, setAddress, setDisable, token }) => {
	const [minDeposit, setMinDeposit] = useState(10);
	const [maxDeposit, setMaxDeposit] = useState(100000);
	const [open, setOpen] = useState(false);

	const changeAgreement = (e) => {
		console.log(e.target.checked);
		setAgreement(e.target.checked);
		setDisable(!e.target.checked);
	};

	const handleCopy = (text) => {
		navigator.clipboard
			.writeText(text)
			.then(() => {
				setOpen(true);
			})
			.catch((err) => {
				console.error("Failed to copy text: ", err);
			});
	};

	useEffect(() => {
		getAddressByCryptoCurrencyNetworkAgent(token, cryptoCurrency, network, (res) => {
			if (res.data) {
				setAddress(res.data.address);
				setMinDeposit(res.data.minDeposit);
				setMaxDeposit(res.data.maxDeposit);
			}
		});
	}, []);

	let isMobile = false;

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		isMobile = true;
	}

	return (
		<>
			{address ? (
				<Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ marginTop: 3 }}>
					<Box sx={{ width: "100%", textAlign: "left", margin: 0, padding: 0 }}>
						<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
							{"Deposit Address"}
						</Typography>
					</Box>
					<Grid size={12}>
						<Card sx={{ borderRadius: "10px", border: "1px solid #CCCCCC", padding: 2, boxShadow: "none" }}>
							<Grid container spacing={2}>
								<Grid size={3}>
									<QRCode value={address ?? ""} bgColor={"white"} fgColor={"black"} size={75} />
								</Grid>
								<Grid size={9} sx={{ textAlign: "left" }}>
									<Typography sx={{ fontSize: "12px" }}>Address</Typography>
									<Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
										{isMobile ? shortAddress(address) : address}
									</Typography>
									<Box sx={{ textAlign: "center" }}>
										<Button
											sx={{ borderRadius: 6, fontSize: "12px", backgroundColor: "#444343", color: "white", marginTop: 2 }}
											size="small"
											onClick={() => handleCopy(address)}
										>
											Copy
										</Button>
										<Snackbar open={open} onClose={() => setOpen(false)} autoHideDuration={2000} message="Copied to clipboard" />
									</Box>
								</Grid>
							</Grid>
						</Card>
					</Grid>
					<Grid size={12}>
						<List>
							<ListItem sx={{ textAlign: "left", width: "100%", display: "flex", padding: 0 }}>
								<img src={one} style={{ marginRight: 6 }} />
								<ListItemText
									primary={<Typography sx={{ fontSize: "13px" }}>Send your deposit to the provided address above.</Typography>}
									sx={{ textAlign: "left", padding: 0, margin: 0 }}
								/>
							</ListItem>
							<ListItem sx={{ textAlign: "left", width: "100%", display: "flex", padding: 0, marginTop: 1 }}>
								<img src={two} style={{ marginRight: 6 }} />
								<ListItemText
									primary={
										<Typography sx={{ fontSize: "13px" }}>
											{`Make sure to select ${returnNetwork(network, cryptoCurrency)} Network.`}
										</Typography>
									}
									sx={{ textAlign: "left", padding: 0, margin: 0 }}
								/>
							</ListItem>
							<ListItem
								sx={{
									textAlign: "left",
									width: "100%",
									display: "flex",
									paddingLeft: 3,
									paddingRight: 3,
									paddingTop: 0,
									paddingBottom: 0,
									color: "#008000",
									margin: 0,
								}}
							>
								<ListItemIcon sx={{ textAlign: "left", padding: 0, margin: 0, minWidth: 25 }}>
									<Checkbox
										edge="start"
										checked={agreement}
										tabIndex={-1}
										disableRipple
										onChange={changeAgreement}
										sx={{ stroke: "#ffffff", strokeWidth: 1 }}
									/>
								</ListItemIcon>
								<ListItemText
									primary={
										<Typography sx={{ fontSize: "10px", fontWeight: "bold", paddingTop: 2 }}>
											{`By checking this box you acknowledge thet you must use the ${returnNetwork(
												network
											)} network for this deposit.`}
										</Typography>
									}
									sx={{ textAlign: "left", padding: 0, margin: 0, fontSize: "0.7em" }}
								/>
							</ListItem>
							<ListItem sx={{ textAlign: "left", width: "100%", display: "flex", padding: 0 }}>
								<img src={three} style={{ marginRight: 6 }} />
								<ListItemText
									primary={
										<Typography sx={{ fontSize: "13px", marginTop: 2 }}>
											Once you have completed your deposit please click on the VERIFY MY DEPOSIT button bellow.
										</Typography>
									}
									sx={{ textAlign: "left", padding: 0, margin: 0 }}
								/>
							</ListItem>
						</List>
					</Grid>
				</Grid>
			) : (
				<CircularProgress color="primary" size={80} thickness={5} />
			)}
		</>
	);
};

export default DepositAddress;
